import { TRACKERS } from "@/constants/Trackers";
import { WomensHealth } from "@/features/Patient/MedicalRecords/WomensHealth/WomensHealth";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/womens-health")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_WOMENS_HEALTH);
  },
});

function RouteComponent() {
  return <WomensHealth />;
}
